import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuItemUpdateStatus } from '~/services/api/contracts/requests/MenuItemUpdateStatus'

// UpdateMenuItemStatusRequest
export const MenuItemUpdateStatusByItem = (
  context: NoContext
): ReturnType<typeof MenuItemUpdateStatus> => MenuItemUpdateStatus(context)
